import axios from 'axios'

export default axios.create({
    // baseURL:'http://localhost:5000/api/'
    // baseURL:'https://qtonixaccount.herokuapp.com/api/XXXXXXXXXXXX'
    baseURL:'https://qtonixemailextract.herokuapp.com/api/'
})